export const isBetween = ({
  beginDate,
  start,
  end,
}: {
  beginDate: Date;
  start: Date;
  end: Date;
}) => {
  const checkInDate = beginDate;
  const startDate = start;
  const endDate = end;
  return checkInDate >= startDate && checkInDate <= endDate;
};
